import { TranslationsType } from "@/app/translations/Translations";

export const T_LogIn: TranslationsType = {
  LOG_IN_LABEL: {
    EN_US: "Log in",
    FR_FR: "Connexion",
  },
  LOG_IN_TITLE: {
    EN_US: "Sign in",
    FR_FR: "Connexion",
  },
  LOG_IN_FIRST_TITLE: {
    EN_US: "Create your password",
    FR_FR: "Créer votre mot de passe",
  },
  LOG_IN_ACTION: {
    EN_US: "Sign in",
    FR_FR: "Se connecter",
  },
  LOG_IN_REMEMBER_ME: {
    EN_US: "Remember me",
    FR_FR: "Se souvenir de moi",
  },
  LOG_IN_FORGOT_PASSWORD: {
    EN_US: "Forgot your password?",
    FR_FR: "Mot de passe oublié ?",
  },
  LOG_IN_NO_ACCOUNT: {
    EN_US: "Don't have an account yet?",
    FR_FR: "Pas encore de compte ?",
  },
  LOG_IN_REQUEST_DEMO: {
    EN_US: "Request a demo",
    FR_FR: "Demander une démo",
  },
  EMAIL: {
    EN_US: "Email address",
    FR_FR: "Adresse e-mail",
  },
  PASSWORD: {
    EN_US: "Password",
    FR_FR: "Mot de passe",
  },
  REPEAT_PASSWORD: {
    EN_US: "Confirm password",
    FR_FR: "Confirmer le mot de passe",
  },
  NEW_PASSWORD: {
    EN_US: "New password",
    FR_FR: "Nouveau mot de passe",
  },
};
